<template>
  <div
    class="profileView"
    :class="{ 'profileView--dark': $vuetify.theme.dark }"
  >
    <v-container class="responsive-height custom-container">

      <!-- top section -->
      <v-row dense>
        <v-col lg="6" md="6" sm="12" cols="12">
          <v-card flat tile :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'" class="my-profile profile-status-card">
            <v-card-actions class="pl-5 align-start py-1">
              <v-icon class="mt-4" color="#708AA7">mdi mdi-account-check-outline</v-icon>
              <v-card-text class="px-0 py-0">
                <v-card-title
                  :style="`color:${client?.profileStatus === 'Not Approved' ? '#e3a600' : client?.profileStatus === 'Pending' ? '#D19909' : '#20d9a0'}`">
                  Profile
                  <span class="ml-1">{{ client?.profileStatus }}</span>
                </v-card-title>
                <v-card-subtitle>Verification Status</v-card-subtitle>
              </v-card-text>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col lg="6" md="6" sm="12" cols="12">
          <v-card flat tile :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'"
            class="d-flex align-center justify-space-between my-profile profile-status-card">
            <v-card-actions class="pl-5 align-start py-1">
              <v-icon class="mt-4" color="#708AA7">mdi mdi-seal-variant</v-icon>
              <v-card-text class="px-0 py-0 align-start">
                <v-card-title>
                  <span
                    :style="`color:${client?.ibStatus === 'Approved' ? '#039de9' : client?.ibStatus === 'Requested' ? '#D19909' : '#FF567F'}`">{{
                      client?.ibStatus }}</span>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon class="ml-2" small color="greenMain" v-bind="attrs" v-on="on">
                        mdi mdi-information-outline
                      </v-icon>
                    </template>
                    <span>Current IB Status</span>
                  </v-tooltip>
                </v-card-title>
                <v-card-subtitle>IB Status</v-card-subtitle>
              </v-card-text>
            </v-card-actions>
            <v-btn v-if="client?.ib_status != 1 || client?.ib_status != 2"
              :disabled="client?.ib_status === 1 || client?.ib_status === 2" class="mx-2 mb-3 security-action-button ib-action-button" tile link small
              elevation="0" color="greenMain" @click.prevent="BECOMEANIB">
              Become an IB
            </v-btn>
          </v-card>
        </v-col>
      </v-row>

      <!-- Personal info section -->
      <v-row dense>
        <v-col lg="6" md="6" sm="12" cols="12">
          <v-card class="user-profile-card identity-profile-card" flat tile :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'">
            <div class="profile-identity-layout">
              <div class="profile-avatar-wrap">
                <div class="profile-avatar-control">
                  <v-avatar size="105" @click="openFileInput" style="border: 2px solid #f1f7fb; border-radius: 100%">
                    <v-img
                      v-if="profileImageUrl && !profileImageFailed"
                      :src="profileImageUrl"
                      :alt="displayName"
                      @error="profileImageFailed = true"
                    />
                    <v-icon v-else class="default-profile-avatar">mdi-account</v-icon>
                  </v-avatar>
                  <button type="button" class="profile-image-button" aria-label="Upload profile image"
                    @click.stop="openFileInput">
                    <v-icon>mdi-camera-outline</v-icon>
                  </button>
                  <input ref="profileImageInput" type="file" @change="handleImageChange" accept="image/*"
                    style="display: none" />
                </div>
              </div>
              <div class="profile-identity-details">
                <div class="profile-name-row">
                  <h3>{{ displayName }}</h3>
                  <span v-if="client?.identity === 1 && client?.resident === 1" class="verified-profile-tag">
                    <v-icon>mdi-shield-check</v-icon> Verified
                  </span>
                </div>
                <dl class="profile-contact-list">
                  <div><dt>User ID</dt><dd>{{ client?.id || "N/A" }}</dd></div>
                  <div><dt>Email</dt><dd>{{ client?.email || "N/A" }}</dd></div>
                </dl>
              </div>
              <v-dialog v-model="passwordDialogOpen" max-width="680" content-class="profile-password-dialog" scrollable>
                <template v-slot:activator="{ on, attrs }">
                  <button type="button" class="change-profile-password-button" v-bind="attrs" v-on="on">
                    <v-icon>mdi-lock-reset</v-icon>
                    Change Password
                  </button>
                </template>
                <div class="profile-password-modal" :class="{ 'profile-password-modal--dark': $vuetify.theme.dark }">
                  <header class="profile-password-modal__header">
                    <div>
                      <h2>Change Profile Password</h2>
                      <p>Securely update your account password using email verification.</p>
                    </div>
                    <v-btn icon class="profile-password-modal__close" @click="passwordDialogOpen = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </header>
                  <change-password-view />
                </div>
              </v-dialog>
            </div>
          </v-card>
        </v-col>
        <v-col lg="6" md="6" sm="12" cols="12">
          <v-card class="user-profile-card personal-information-card" flat tile :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'">
            <v-card-title class="d-flex justify-space-between align-center">
              <span>{{ isCompanyAccount ? "Company Information" : "Personal Information" }}</span>
              <v-dialog v-model="editDialogOpen" @open="initializeFormData" transition="scale-transition"
                origin="center center" max-width="554" content-class="deposit-withdraw-popup">
                <template v-slot:activator="{ on, attrs }">
                  <span class="edit" v-bind="attrs" v-on="on" @click="initializeFormData">Edit</span>
                </template>
                <template v-slot:default="dialog">
                  <v-card class="deposit-form profile-edit-modal"
                    :class="{ 'profile-edit-modal--dark': $vuetify.theme.dark }">
                    <header class="profile-edit-modal__header">
                      <div>
                        <v-icon>{{ isCompanyAccount ? "mdi-domain" : "mdi-account-edit-outline" }}</v-icon>
                        <h2>Edit {{ isCompanyAccount ? "Company Information" : "Personal Information" }}</h2>
                      </div>
                      <v-btn icon aria-label="Close" @click="dialog.value = false"><v-icon>mdi-close</v-icon></v-btn>
                    </header>

                    <v-row v-if="!isCompanyAccount" class="profile-edit-modal__body">
                      <!-- Country Selection -->
                      <v-col cols="12" sm="6" md="6" lg="6">
                        <fieldset>
                          <legend>Country</legend>
                          <v-select v-model="clientInfo.country" @input="onCountryChange" :items="countries"
                            item-text="name" item-value="id" :value="client?.country_id" solo
                            append-icon="mdi-chevron-down" label="Select One" class="custom-select" hide-details
                            single-line>
                          </v-select>
                        </fieldset>
                      </v-col>

                      <!-- State Selection -->
                      <v-col cols="12" sm="6" md="6" lg="6">
                        <fieldset>
                          <legend>State Province</legend>
                          <v-select v-model="clientInfo.state" @input="onStateChange" :items="states" item-text="name"
                            item-value="id" :value="client?.state_id" solo append-icon="mdi-chevron-down"
                            label="Select One" class="custom-select" hide-details>
                          </v-select>
                        </fieldset>
                      </v-col>

                      <!-- City Province and Postal Code -->
                      <v-col cols="12" sm="6" md="6" lg="6">
                        <fieldset>
                          <legend>City</legend>
                          <v-select v-model="clientInfo.city" @input="onCityChange" :items="cities" item-text="name"
                            item-value="id" :value="client?.city_id" solo append-icon="mdi-chevron-down"
                            label="Select One" class="custom-select" hide-details>
                          </v-select>
                        </fieldset>
                      </v-col>

                      <v-col cols="12" sm="6" md="6" lg="6">
                        <fieldset>
                          <legend>Postal Code</legend>
                          <v-text-field v-model="clientInfo.postal_code" :placeholder="client?.postal_code" single-line
                            solo hide-details class="custom-select">
                          </v-text-field>
                        </fieldset>
                      </v-col>

                      <!-- Street Address -->
                      <v-col cols="12" sm="12" md="12" lg="12">
                        <fieldset class="textarea-field">
                          <legend>Street Address</legend>
                          <v-textarea v-model="clientInfo.address" :placeholder="client?.address" single-line solo
                            hide-details class="custom-textarea">
                          </v-textarea>
                        </fieldset>
                      </v-col>

                      <!-- Birthday Date -->
                      <v-col cols="12" sm="12" md="12" lg="12">
                        <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition"
                          offset-y min-width="auto">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="date" label="Birthday date" prepend-icon="mdi-calendar" readonly
                              v-bind="attrs" v-on="on" single-line solo hide-details
                              class="custom-select-datepicker"></v-text-field>
                          </template>
                          <v-date-picker v-model="date" :active-picker.sync="activePicker" :max="new Date(
                            Date.now() -
                            new Date().getTimezoneOffset() * 60000
                          )
                            .toISOString()
                            .substring(0, 10)
                            " min="1950-01-01" @change="SaveMenu"></v-date-picker>
                        </v-menu>
                      </v-col>

                      <!-- Phone Number -->
                      <v-col cols="12" sm="12" md="12" lg="12">
                        <fieldset>
                          <legend>Phone Number</legend>
                          <v-text-field v-model="clientInfo.mobile" :placeholder="client?.mobile" single-line solo
                            hide-details class="custom-select">
                          </v-text-field>
                        </fieldset>
                      </v-col>

                      <!-- Update button -->
                      <v-col cols="12" sm="12" md="12" lg="12">
                        <v-btn :loading="isLoading" :disabled="isLoading" tile elevation="0"
                          class="ma-0 text-capitalize btn-account px-10" color="greenMain"
                          @click.prevent="updateProfile">
                          Update
                        </v-btn>
                      </v-col>
                    </v-row>

                    <v-row v-else class="profile-edit-modal__body">
                      <v-col cols="12" sm="6">
                        <fieldset>
                          <legend>Legal Company Name</legend>
                          <v-text-field v-model="companyInfo.company_name" single-line solo hide-details
                            class="custom-select" />
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <fieldset>
                          <legend>Trading Name</legend>
                          <v-text-field v-model="companyInfo.trading_name" single-line solo hide-details
                            class="custom-select" />
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <fieldset>
                          <legend>Registration Number</legend>
                          <v-text-field v-model="companyInfo.company_reg_no" single-line solo hide-details
                            class="custom-select" />
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <fieldset>
                          <legend>Company Type</legend>
                          <v-text-field v-model="companyInfo.company_type" single-line solo hide-details
                            class="custom-select" />
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <fieldset>
                          <legend>Country of Incorporation</legend>
                          <v-select v-model="companyInfo.country" :items="countries" item-text="name" item-value="id"
                            solo append-icon="mdi-chevron-down" label="Select One" class="custom-select" hide-details />
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <fieldset>
                          <legend>Date of Incorporation</legend>
                          <v-text-field v-model="companyInfo.incorporation_date" type="date" single-line solo
                            hide-details class="custom-select" />
                        </fieldset>
                      </v-col>
                      <v-col cols="12">
                        <fieldset class="textarea-field">
                          <legend>Registered Office Address</legend>
                          <v-textarea v-model="companyInfo.registered_address" single-line solo hide-details
                            class="custom-textarea" />
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <fieldset>
                          <legend>City / Town</legend>
                          <v-text-field v-model="companyInfo.city" single-line solo hide-details
                            class="custom-select" />
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <fieldset>
                          <legend>State / Province</legend>
                          <v-text-field v-model="companyInfo.state" single-line solo hide-details
                            class="custom-select" />
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <fieldset>
                          <legend>Postal / ZIP Code</legend>
                          <v-text-field v-model="companyInfo.postal_code" single-line solo hide-details
                            class="custom-select" />
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <fieldset>
                          <legend>Company Phone</legend>
                          <v-text-field v-model="companyInfo.phone_no" single-line solo hide-details
                            class="custom-select" />
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <fieldset>
                          <legend>Website</legend>
                          <v-text-field v-model="companyInfo.website" single-line solo hide-details
                            class="custom-select" />
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <fieldset>
                          <legend>Director Name</legend>
                          <v-text-field v-model="companyInfo.director_name" single-line solo hide-details
                            class="custom-select" />
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <fieldset>
                          <legend>Director Position</legend>
                          <v-text-field v-model="companyInfo.director_position" single-line solo hide-details
                            class="custom-select" />
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <fieldset>
                          <legend>Director Email</legend>
                          <v-text-field v-model="companyInfo.director_email" single-line solo hide-details
                            class="custom-select" />
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <fieldset>
                          <legend>Director Phone</legend>
                          <v-text-field v-model="companyInfo.director_phone" single-line solo hide-details
                            class="custom-select" />
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <fieldset>
                          <legend>Owner Name</legend>
                          <v-text-field v-model="companyInfo.owner_name" single-line solo hide-details
                            class="custom-select" />
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <fieldset>
                          <legend>Ownership Percentage</legend>
                          <v-text-field v-model="companyInfo.owner_percentage" single-line solo hide-details
                            class="custom-select" />
                        </fieldset>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <fieldset>
                          <legend>Owner Control Type</legend>
                          <v-text-field v-model="companyInfo.owner_control_type" single-line solo hide-details
                            class="custom-select" />
                        </fieldset>
                      </v-col>
                      <v-col cols="12">
                        <v-btn :loading="isLoading" :disabled="isLoading" tile elevation="0"
                          class="ma-0 text-capitalize btn-account px-10" color="greenMain"
                          @click.prevent="updateProfile">
                          Update
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card>
                </template>
              </v-dialog>
            </v-card-title>
            <v-card-actions v-if="!isCompanyAccount">
              <v-card-text class="py-0 pr-0">
                <v-card-text class="pa-0">
                  <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle">
                    <span>Country: </span>
                    <span>{{ client?.countries?.name || "N/A" }}</span>
                  </v-card-subtitle>
                  <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle">
                    <span>Phone No: </span>
                    <span>{{ client?.mobile || "N/A" }}</span>
                  </v-card-subtitle>
                  <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle">
                    <span>State: </span>
                    <span>{{ client?.states?.name || "N/A" }}</span>
                  </v-card-subtitle>
                  <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle">
                    <span>Date of Birth: </span>
                    <span>{{ formatDate(client?.dob) || "N/A" }}</span>
                  </v-card-subtitle>
                </v-card-text>
              </v-card-text>
              <v-card-text class="py-0 pr-0">
                <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle">
                  <span>City: </span>
                  <span>{{ client?.cities?.name || "N/A" }}</span>
                </v-card-subtitle>
                <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle">
                  <span>Zipcode: </span>
                  <span>{{ client?.postal_code || "N/A" }}</span>
                </v-card-subtitle>
                <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle">
                  <span>Street Address: </span>
                  <span>{{ client?.address || "N/A" }}</span>
                </v-card-subtitle>
              </v-card-text>
            </v-card-actions>
            <v-card-actions v-else>
              <v-card-text class="py-0 pr-0">
                <v-card-text class="pa-0">
                  <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle">
                    <span>Company Name: </span>
                    <span>{{ companyRegistration?.company_name || client?.company_name || "N/A" }}</span>
                  </v-card-subtitle>
                  <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle">
                    <span>Registration No: </span>
                    <span>{{ companyRegistration?.company_reg_no || client?.reg_no || "N/A" }}</span>
                  </v-card-subtitle>
                  <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle">
                    <span>Company Type: </span>
                    <span>{{ companyRegistration?.company_type || "N/A" }}</span>
                  </v-card-subtitle>
                  <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle">
                    <span>Country: </span>
                    <span>{{ companyCountryName || "N/A" }}</span>
                  </v-card-subtitle>
                  <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle">
                    <span>Phone No: </span>
                    <span>{{ companyRegistration?.phone_no || client?.mobile || "N/A" }}</span>
                  </v-card-subtitle>
                </v-card-text>
              </v-card-text>
              <v-card-text class="py-0 pr-0">
                <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle">
                  <span>Director: </span>
                  <span>{{ companyRegistration?.director_name || "N/A" }}</span>
                </v-card-subtitle>
                <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle">
                  <span>Owner: </span>
                  <span>{{ companyRegistration?.owner_name || "N/A" }}</span>
                </v-card-subtitle>
                <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle">
                  <span>Website: </span>
                  <span>{{ companyRegistration?.website || "N/A" }}</span>
                </v-card-subtitle>
                <v-card-subtitle class="pa-0 mb-2 listing-v-card__subtitle">
                  <span>Registered Address: </span>
                  <span>{{ companyRegistration?.registered_address || client?.address || "N/A" }}</span>
                </v-card-subtitle>
              </v-card-text>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <!-- ✅ 2FA Management section (TOGGLE) -->
      <v-row dense v-if="show2faBlock" class="security-summary-row">
        <v-col cols="12">
          <v-card flat tile :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'"
            class="d-flex align-center justify-space-between my-profile">
            <v-card-actions class="pl-5 align-start py-1">
              <v-icon class="mt-4" color="#708AA7">mdi-shield-key-outline</v-icon>
              <v-card-text class="px-0 py-0">
                <v-card-title class="terms">Two-Factor Authentication (2FA)</v-card-title>
                <v-card-subtitle>
                  Secure your account with Authenticator app
                </v-card-subtitle>
              </v-card-text>
            </v-card-actions>

            <div class="d-flex align-center">
              <!-- ✅ same button toggles -->
              <v-btn class="mx-2 mb-3 security-action-button" tile small elevation="0" :color="is2faEnabled ? '#FF567F' : 'primary'"
                @click="open2faToggleDialog">
                {{ is2faEnabled ? "Disable 2FA" : "Enable 2FA" }}
              </v-btn>
            </div>
          </v-card>

          <v-dialog v-model="twoFaDialog" max-width="680" content-class="twofa-dialog"
            transition="dialog-bottom-transition">
            <v-card class="twofa-card" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
              <!-- Header -->
              <div class="twofa-header d-flex align-center justify-space-between px-6 py-4">
                <div class="d-flex align-center">
                  <v-icon class="mr-3" :color="$vuetify.theme.dark ? '#7EA6D6' : '#3B5B7A'">
                    mdi-shield-key-outline
                  </v-icon>

                  <div>
                    <div class="twofa-title">{{ twoFaDialogTitle }}</div>
                    <div class="twofa-subtitle">
                      {{ twoFaMode === 'disable'
                        ? 'Confirm with your authenticator code to turn it off.'
                        : 'Use an authenticator app to keep your account secure.' }}
                    </div>
                  </div>
                </div>

                <v-btn icon @click="close2faDialog" class="twofa-close"
                  :color="$vuetify.theme.dark ? '#E6F0FF' : '#172233'">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>

              <v-divider class="twofa-divider" />

              <!-- Body -->
              <v-card-text class="px-6 pt-5 pb-0">
                <div class="twofa-steps mb-5">
                  <div class="twofa-step" v-if="twoFaMode === 'setup'">
                    <div class="step-title">Setup steps</div>
                    <ol class="step-list">
                      <li>Install Google Authenticator (or similar)</li>
                      <li>Scan the QR code</li>
                      <li>Enter the 6-digit code to enable 2FA</li>
                    </ol>
                  </div>

                  <div class="twofa-step" v-else-if="twoFaMode === 'activate'">
                    <div class="step-title">Enable 2FA</div>
                    <ol class="step-list">
                      <li>Your authenticator is already registered</li>
                      <li>Open your authenticator app</li>
                      <li>Enter the 6-digit code to enable</li>
                    </ol>
                  </div>

                  <div class="twofa-step" v-else>
                    <div class="step-title">Disable 2FA</div>
                    <ol class="step-list">
                      <li>Open your authenticator app</li>
                      <li>Enter the 6-digit code to disable</li>
                    </ol>
                  </div>
                </div>

                <v-row align="stretch" class="pb-2">
                  <!-- QR panel -->
                  <v-col cols="12" md="5" v-if="twoFaMode === 'setup'">
                    <div class="twofa-qr-wrap">
                      <div class="qr-title mb-3">Scan QR</div>
                      <v-skeleton-loader v-if="twoFaLoading" type="image" />
                      <v-img v-else :src="twoFaSetup?.qr" max-width="240" contain class="mx-auto twofa-qr" />
                      <div class="qr-hint mt-3">
                        Use your authenticator app to scan this code.
                      </div>
                    </div>
                  </v-col>

                  <!-- OTP panel -->
                  <v-col cols="12" :md="twoFaMode === 'setup' ? 7 : 12">
                    <div class="twofa-otp-wrap">
                      <div class="otp-title mb-2">Authenticator code</div>

                      <v-text-field v-model="twoFaOtp" placeholder="123456" solo hide-details maxlength="6"
                        class="twofa-otp-input" :background-color="$vuetify.theme.dark ? '#0F1B2A' : '#FFFFFF'"
                        :color="$vuetify.theme.dark ? '#E6F0FF' : '#172233'"
                        @input="twoFaOtp = (twoFaOtp || '').replace(/[^0-9]/g, '').slice(0, 6)"
                        prepend-inner-icon="mdi-lock-outline" />

                      <v-btn class="mt-4 twofa-action" tile elevation="0"
                        :color="twoFaMode === 'disable' ? '#FF567F' : 'greenMain'" :loading="twoFaConfirmLoading"
                        :disabled="twoFaConfirmLoading || (twoFaOtp || '').length !== 6" @click="confirmTwoFaToggle">
                        {{ twoFaConfirmBtnText }}
                      </v-btn>

                      <div class="otp-note mt-3" v-if="twoFaMode !== 'disable'">
                        Tip: If the code fails, wait for the next code and try again.
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions class="px-6 pb-5 pt-0">
                <v-spacer />
                <v-btn text class="twofa-cancel" @click="close2faDialog">
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

        </v-col>
      </v-row>


      <!-- terms and conditions section -->
      <v-row dense class="terms-summary-row">
        <v-col lg="12" md="12" sm="12" cols="12">
          <v-card flat tile :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'"
            class="d-flex align-center justify-space-between my-profile">
            <v-card-actions class="pl-5 align-start py-1">
              <v-icon class="mt-4" color="#708AA7">mdi-file-document-outline</v-icon>
              <v-card-text class="px-0 py-0">
                <v-card-title class="terms">
                  Your Terms & Conditions
                </v-card-title>
                <v-card-subtitle>By using our platform, you agree to our terms</v-card-subtitle>
              </v-card-text>
            </v-card-actions>
            <v-btn class="mx-2 mb-3 terms-action-button" tile link to="/terms-and-condition" small elevation="0">
              See T&C / Approve
            </v-btn>
          </v-card>
        </v-col>
      </v-row>

      <!-- Identity and residence verifiation section -->
      <v-row dense class="verification-summary-row">
        <!-- LEFT SIDE: RESIDENCE VERIFICATION -->
        <v-col lg="6" md="6" sm="12" cols="12">
          <v-card v-if="client?.resident !== 1" class="verification-card" flat tile
            :color="$vuetify.theme.dark ? '#172233' : '#FEFEFF'">
            <v-card-actions class="justify-space-between px-0">
              <v-card-title class="pl-1">
                <v-icon class="pr-5" color="#5a89f0">mdi mdi-home-lightning-bolt-outline</v-icon>
                Residence Verification
              </v-card-title>

              <v-dialog transition="scale-transition" origin="center center" max-width="654"
                content-class="deposit-withdraw-popup">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn tile text elevation="0" class="text-capitalize link text-decoration-underline" color="#5a89f0"
                    v-bind="attrs" v-on="on">
                    View Details
                  </v-btn>
                </template>

                <template v-slot:default="dialog">
                  <v-card class="verification-detail-modal" :class="{ 'verification-detail-modal--dark': $vuetify.theme.dark }">
                    <header class="verification-detail-header">
                      <div><v-icon>mdi-home-check-outline</v-icon><h2>Residence Verification</h2></div>
                      <v-btn icon aria-label="Close" @click="dialog.value = false"><v-icon>mdi-close</v-icon></v-btn>
                    </header>
                    <div class="verification-detail-body">
                      <p>Upload a recent document showing your full name and residential address.</p>
                      <h3>Accepted documents</h3>
                      <ul><li>Utility bill</li><li>Bank statement</li><li>Government residence document</li></ul>
                      <div class="verification-detail-note"><v-icon>mdi-information-outline</v-icon>
                        <span>Use a clear colour JPG, JPEG, or PNG under 4MB. The document should be issued within the last three months.</span>
                      </div>
                    </div>
                  </v-card>
                </template>
              </v-dialog>
            </v-card-actions>

            <!-- RESIDENCE VERIFICATION -->
            <v-card-subtitle class="text-center">
              <span class="d-block">Upload: Verify your residential address,</span>
              kindly submit supporting documents in either PNG, JPG, or JPEG
              format.
            </v-card-subtitle>

            <div class="custom-upload-area">
              <input type="file" ref="residenceFileInput" class="file-input" accept="image/jpeg,image/jpg,image/png"
                @change="handleResidenceFile" />

              <div class="content">
                <v-row style="position: absolute; bottom: 40px; right: 50%" v-if="residentUploading">
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>

                <v-icon large class="mb-3" color="#5a89f0">mdi mdi-tray-arrow-up</v-icon>
                <p class="mb-0">Drop File Here or <strong>Browse</strong></p>
                <span class="text-sm">File size max 4MB</span>
              </div>
            </div>
            <div v-if="(getDocuments('residence') || []).length" class="verification-history verification-history--unverified">
              <div class="verification-history-row verification-history-head">
                <span>Date &amp; Time</span><span>Comment</span><span>Status</span><span>By</span>
              </div>
              <div v-for="data in (getDocuments('residence') || []).slice(0, 4)" :key="`residence-pending-${data.id}`"
                class="verification-history-row">
                <strong>{{ formatMySQLDate(data.created_at) }}</strong>
                <button type="button" @click="$set(dialogs, `comment_residence_${data.id}`, true)">See Details</button>
                <span class="history-status" :class="`history-status--${data.status}`">
                  {{ data.status === 2 ? "Pending" : data.status === 1 ? "Approved" : "Rejected" }}
                </span>
                <span>Admin</span>
              </div>
              <button type="button" class="view-history-button">
                <v-icon>mdi-history</v-icon> View All History
              </button>
            </div>
          </v-card>

          <v-card v-else class="verification-card pb-0" style="height: 100%" flat tile
            :color="$vuetify.theme.dark ? '#172233' : '#FEFEFF'">
            <v-card-actions class="justify-space-between px-0">
              <v-card-title class="pl-1">
                <v-icon class="pr-5" color="#5a89f0">mdi mdi-home-lightning-bolt-outline</v-icon>
                Residence Verification
              </v-card-title>

              <v-dialog transition="scale-transition" origin="center center" max-width="654"
                content-class="deposit-withdraw-popup">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn tile text elevation="0" class="text-capitalize link text-decoration-underline" color="#5a89f0"
                    v-bind="attrs" v-on="on">
                    View Details
                  </v-btn>
                </template>

                <template v-slot:default="dialog">
                  <v-card class="verification-detail-modal" :class="{ 'verification-detail-modal--dark': $vuetify.theme.dark }">
                    <header class="verification-detail-header">
                      <div><v-icon>mdi-home-check-outline</v-icon><h2>Residence Verification</h2></div>
                      <v-btn icon aria-label="Close" @click="dialog.value = false"><v-icon>mdi-close</v-icon></v-btn>
                    </header>
                    <div class="verification-detail-body">
                      <p>Upload a recent document showing your full name and residential address.</p>
                      <h3>Accepted documents</h3>
                      <ul><li>Utility bill</li><li>Bank statement</li><li>Government residence document</li></ul>
                      <div class="verification-detail-note"><v-icon>mdi-information-outline</v-icon>
                        <span>Use a clear colour JPG, JPEG, or PNG under 4MB. The document should be issued within the last three months.</span>
                      </div>
                    </div>
                  </v-card>
                </template>
              </v-dialog>
            </v-card-actions>

            <v-card-text class="content">
              <v-icon color="greenMain">mdi mdi-home-sound-in-outline</v-icon>
              <h3>Residence Verified</h3>
            </v-card-text>
            <div class="verification-history">
              <div class="verification-history-row verification-history-head">
                <span>Date &amp; Time</span><span>Comment</span><span>Status</span><span>By</span>
              </div>
              <div v-for="data in (getDocuments('residence') || []).slice(0, 4)" :key="`residence-${data.id}`"
                class="verification-history-row">
                <strong>{{ formatMySQLDate(data.created_at) }}</strong>
                <button type="button" @click="$set(dialogs, `comment_residence_${data.id}`, true)">See Details</button>
                <span class="history-status" :class="`history-status--${data.status}`">
                  {{ data.status === 2 ? "Pending" : data.status === 1 ? "Approved" : "Rejected" }}
                </span>
                <span>Admin</span>
              </div>
              <button v-if="(getDocuments('residence') || []).length" type="button" class="view-history-button">
                <v-icon>mdi-history</v-icon> View All History
              </button>
            </div>
          </v-card>
        </v-col>

        <!-- RIGHT SIDE: IDENTITY VERIFICATION -->
        <v-col lg="6" md="6" sm="12" cols="12">
          <v-card v-if="client?.identity !== 1" class="verification-card" flat tile
            :color="$vuetify.theme.dark ? '#172233' : '#FEFEFF'">
            <v-card-actions class="justify-space-between px-0">
              <v-card-title class="pl-1">
                <v-icon class="pr-5" color="#5a89f0">mdi mdi-account-outline</v-icon>
                Identity Verification
              </v-card-title>

              <v-dialog transition="scale-transition" origin="center center" max-width="554"
                content-class="deposit-withdraw-popup">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn tile text elevation="0" class="text-capitalize link text-decoration-underline" color="#5a89f0"
                    v-bind="attrs" v-on="on">
                    View Details
                  </v-btn>
                </template>

                <template v-slot:default="dialog">
                  <v-card class="verification-detail-modal" :class="{ 'verification-detail-modal--dark': $vuetify.theme.dark }">
                    <header class="verification-detail-header">
                      <div><v-icon>mdi-account-check-outline</v-icon><h2>Identity Verification</h2></div>
                      <v-btn icon aria-label="Close" @click="dialog.value = false"><v-icon>mdi-close</v-icon></v-btn>
                    </header>
                    <div class="verification-detail-body">
                      <p>Upload a valid identity document with your full name, photo, and date of birth clearly visible.</p>
                      <h3>Accepted documents</h3>
                      <ul><li>National identity card</li><li>Passport</li><li>Driver's licence</li></ul>
                      <div class="verification-detail-note"><v-icon>mdi-information-outline</v-icon>
                        <span>Use a clear colour JPG, JPEG, or PNG under 4MB. Show all four edges and ensure the document has not expired.</span>
                      </div>
                    </div>
                  </v-card>
                </template>
              </v-dialog>
            </v-card-actions>

            <!-- IDENTITY VERIFICATION -->
            <v-card-subtitle class="text-center">
              <span class="d-block">
                Upload: Local or international passport (ID, IC), National Indentity Card
              </span>
              or driver's licens in either PNG, JPG, or JPEG format.
            </v-card-subtitle>

            <div class="custom-upload-area">
              <input type="file" ref="identityFileInput" class="file-input" accept="image/jpeg,image/jpg,image/png"
                @change="handleIdentityFile" />

              <div class="content">
                <v-row style="position: absolute; bottom: 40px; right: 50%" v-if="identityUploading">
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>

                <v-icon large class="mb-3" color="#5a89f0">mdi mdi-tray-arrow-up</v-icon>
                <p class="mb-0">Drop File Here or <strong>Browse</strong></p>
                <span class="text-sm">File size max 4MB</span>
              </div>
            </div>
            <div v-if="(getDocuments('identity') || []).length" class="verification-history verification-history--unverified">
              <div class="verification-history-row verification-history-head">
                <span>Date &amp; Time</span><span>Comment</span><span>Status</span><span>By</span>
              </div>
              <div v-for="data in (getDocuments('identity') || []).slice(0, 4)" :key="`identity-pending-${data.id}`"
                class="verification-history-row">
                <strong>{{ formatMySQLDate(data.created_at) }}</strong>
                <button type="button" @click="$set(dialogs, `comment_identity_${data.id}`, true)">See Details</button>
                <span class="history-status" :class="`history-status--${data.status}`">
                  {{ data.status === 2 ? "Pending" : data.status === 1 ? "Approved" : "Rejected" }}
                </span>
                <span>Admin</span>
              </div>
              <button type="button" class="view-history-button">
                <v-icon>mdi-history</v-icon> View All History
              </button>
            </div>
          </v-card>

          <v-card v-else class="verification-card pb-0" style="height: 100%;" flat tile
            :color="$vuetify.theme.dark ? '#172233' : '#FEFEFF'">
            <v-card-actions class="justify-space-between px-0">
              <v-card-title class="pl-1">
                <v-icon class="pr-5" color="#5a89f0">mdi mdi-account-outline</v-icon>
                Identity Verification
              </v-card-title>

              <v-dialog transition="scale-transition" origin="center center" max-width="654"
                content-class="deposit-withdraw-popup">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn tile text elevation="0" class="text-capitalize link text-decoration-underline" color="#5a89f0"
                    v-bind="attrs" v-on="on">
                    View Details
                  </v-btn>
                </template>

                <template v-slot:default="dialog">
                  <v-card class="verification-detail-modal" :class="{ 'verification-detail-modal--dark': $vuetify.theme.dark }">
                    <header class="verification-detail-header">
                      <div><v-icon>mdi-account-check-outline</v-icon><h2>Identity Verification</h2></div>
                      <v-btn icon aria-label="Close" @click="dialog.value = false"><v-icon>mdi-close</v-icon></v-btn>
                    </header>
                    <div class="verification-detail-body">
                      <p>Upload a valid identity document with your full name, photo, and date of birth clearly visible.</p>
                      <h3>Accepted documents</h3>
                      <ul><li>National identity card</li><li>Passport</li><li>Driver's licence</li></ul>
                      <div class="verification-detail-note"><v-icon>mdi-information-outline</v-icon>
                        <span>Use a clear colour JPG, JPEG, or PNG under 4MB. Show all four edges and ensure the document has not expired.</span>
                      </div>
                    </div>
                  </v-card>
                </template>
              </v-dialog>
            </v-card-actions>

            <v-card-text class="content">
              <v-icon color="greenMain">mdi mdi-account-check-outline</v-icon>
              <h3>Identity Verified</h3>
            </v-card-text>
            <div class="verification-history">
              <div class="verification-history-row verification-history-head">
                <span>Date &amp; Time</span><span>Comment</span><span>Status</span><span>By</span>
              </div>
              <div v-for="data in (getDocuments('identity') || []).slice(0, 4)" :key="`identity-${data.id}`"
                class="verification-history-row">
                <strong>{{ formatMySQLDate(data.created_at) }}</strong>
                <button type="button" @click="$set(dialogs, `comment_identity_${data.id}`, true)">See Details</button>
                <span class="history-status" :class="`history-status--${data.status}`">
                  {{ data.status === 2 ? "Pending" : data.status === 1 ? "Approved" : "Rejected" }}
                </span>
                <span>Admin</span>
              </div>
              <button v-if="(getDocuments('identity') || []).length" type="button" class="view-history-button">
                <v-icon>mdi-history</v-icon> View All History
              </button>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <!-- uploaded images status section -->
      <v-row dense class="document-history-row">
        <v-col lg="6" md="6" sm="12" cols="12" v-for="(type, typeIndex) in ['residence', 'identity']" :key="type">
          <v-card v-for="(data, index) in getDocuments(type)" :key="index" flat tile
            :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'" class="listing-upload">
            <v-row no-gutters justify="space-between" align="center">
              <v-col cols="4">
                <v-card-title>Date & Time</v-card-title>
                <v-card-subtitle class="text-start">{{ formatMySQLDate(data?.created_at) }}</v-card-subtitle>
              </v-col>

              <v-col cols="3">
                <v-card-title class="comment-title">Comment</v-card-title>
                <v-dialog transition="scale-transition" origin="center center" max-width="554"
                  content-class="deposit-withdraw-popup" v-model="dialogs[`comment_${type}_${data?.id}`]">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text elevation="0" class="text-capitalize pa-0 see-details-btn" v-bind="attrs" v-on="on">See
                      Details</v-btn>
                  </template>
                  <v-card class="rounded-0" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                    <v-btn icon :color="$vuetify.theme.dark ? '#F1F7FB' : '#172233'"
                      @click="closeDialog(`comment_${type}_${data?.id}`)"
                      style="position: absolute; top: 1rem; right: 1rem; z-index: 1;">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-card-title class="rounded-0">Comment</v-card-title>
                    <ol style="list-style-type: none">
                      <li>{{ data?.comment }}</li>
                    </ol>
                  </v-card>
                </v-dialog>
              </v-col>

              <v-col cols="2">
                <v-card-title class="d-block">Status</v-card-title>
                <v-card-subtitle
                  :style="{ color: data?.status === 2 ? '#D19909' : data?.status === 1 ? '#039de9' : '#ff567f' }">
                  {{ data?.status === 2 ? "Pending" : data?.status === 1 ? "Approved" : "Rejected" }}
                </v-card-subtitle>
              </v-col>

              <v-col cols="2">
                <v-dialog max-width="554" v-model="dialogs[`image_${type}_${data?.id}`]">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn elevation="0" v-bind="attrs" v-on="on" class="icon-btn"
                      @click="openImagePreview(type, data)">
                      <v-img class="white--text align-end" :src="data?.document_url" width="40"></v-img>
                    </v-btn>
                  </template>
                  <v-card class="rounded-0 bg-transparent" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                    <v-btn icon :color="$vuetify.theme.dark ? '#F1F7FB' : '#172233'"
                      @click="closeDialog(`image_${type}_${data?.id}`)"
                      style="position: absolute; top: 1rem; right: 1rem; z-index: 1;">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-img class="white--text align-end" :src="previewImages[type]"></v-img>
                  </v-card>
                </v-dialog>
              </v-col>

              <v-col cols="1">
                <v-btn v-if="data?.status === 2" small :loading="closeLoading[data?.id]"
                  :disabled="closeLoading[data?.id]" class="closeBtn" @click.prevent="deleteImage(type, data)">
                  <v-icon :color="$vuetify.theme.dark ? '#ff567f' : '#f38da7'">mdi-close</v-icon>
                </v-btn>
                <v-icon v-else class="align-center" color="#708AA7">mdi-dots-horizontal</v-icon>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <section class="verification-benefits" aria-label="Verification benefits">
        <div class="verification-benefit">
          <span class="benefit-icon benefit-icon--purple"><v-icon>mdi-shield-check-outline</v-icon></span>
          <div><strong>Why Verify?</strong><p>Verification increases your account security and limits.</p></div>
        </div>
        <div class="verification-benefit">
          <span class="benefit-icon benefit-icon--green"><v-icon>mdi-lightning-bolt-outline</v-icon></span>
          <div><strong>Faster Withdrawal</strong><p>Verified accounts enjoy faster withdrawals.</p></div>
        </div>
        <div class="verification-benefit">
          <span class="benefit-icon benefit-icon--gold"><v-icon>mdi-shield-star-outline</v-icon></span>
          <div><strong>Higher Limits</strong><p>Get higher deposit and withdrawal limits.</p></div>
        </div>
        <div class="verification-benefit">
          <span class="benefit-icon benefit-icon--blue"><v-icon>mdi-lock-outline</v-icon></span>
          <div><strong>Trusted Platform</strong><p>Trade in a safe and secure environment.</p></div>
        </div>
        <v-icon class="benefits-shield">mdi-shield-check</v-icon>
      </section>

    </v-container>
  </div>
</template>

<script>
import toast from "@/services/Notification";
import {
  CITIES__ACTIONS,
  COUNTRIES__ACTIONS,
  PROFILE__ACTIONS,
  STATES__ACTIONS,
} from "@/store/action-types";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { mapActions, mapState } from "vuex";
import ChangePasswordView from "@/views/auth/ChangePassword";

export default {
  name: "profileAndVerification",
  components: {
    vueDropzone: vue2Dropzone,
    ChangePasswordView,
  },
  data() {
    return {
      activePicker: "",
      clientInfo: {
        country: "",
        city: "",
        state: "",
        postal_code: "",
        address: "",
        dob: "",
        mobile: "",
      },
      companyInfo: {
        company_name: "",
        trading_name: "",
        company_reg_no: "",
        company_type: "",
        country: "",
        incorporation_date: "",
        registered_address: "",
        city: "",
        state: "",
        postal_code: "",
        phone_no: "",
        website: "",
        director_name: "",
        director_position: "",
        director_email: "",
        director_phone: "",
        owner_name: "",
        owner_percentage: "",
        owner_control_type: "",
      },
      // ✅ 2FA states
      twoFaDialog: false,
      twoFaLoading: false,
      twoFaConfirmLoading: false,
      twoFaOtp: "",
      twoFaMode: "setup", // 'setup' | 'activate' | 'disable'

      closeLoading: {},
      date: "",
      dialogs: {},
      dragging: false,
      dropzoneOptions: {
        acceptedFiles: "image/jpeg,image/png",
        url: "https://httpbin.org/post",
        thumbnailWidth: 100,
        maxFilesize: 3 * 1024 * 1024,
        headers: { "My-Awesome-Header": "header value" },
        maxFiles: 1,
        addRemoveLinks: true,
      },
      editDialogOpen: false,
      identityUploading: false,
      isLoading: false,
      menu: false,
      origin: "",
      passwordDialogOpen: false,
      pdfImage: window.location.origin + "/static/images/pdf.png",
      previewImages: {
        identity: "",
        residence: ""
      },
      profileImageFailed: false,
      residentUploading: false,
    };
  },
  computed: {
    ...mapState("cities", ["cities"]),
    ...mapState("countries", ["countries"]),
    ...mapState("profile", ["client", "documentInfo", "twoFaSetup"]),
    ...mapState("states", ["states"]),

    // ✅ show/hide 2FA block (broker flag)
    show2faBlock() {
      if (!this.client) return false;
      if (this.client.client_2fa_enabled === undefined) return true;
      return Number(this.client.client_2fa_enabled) === 1;
    },

    // ✅ enabled status (user flag)
    is2faEnabled() {
      const v =
        this.client?.two_fa_enabled ?? this.client?.two_step_verification ?? 0;
      return Number(v) === 1;
    },

    // ✅ registered secret exists (NO need to expose real secret)
    has2faSecret() {
      // backend recommended flag
      if (this.client?.two_fa_secret_exists !== undefined) {
        return Number(this.client.two_fa_secret_exists) === 1;
      }
      // fallback
      const s = this.client?.two_fa_secret;
      return !!(s && String(s).trim().length > 0);
    },

    isCompanyAccount() {
      return Number(this.client?.owner_type) === 2;
    },

    companyRegistration() {
      return this.client?.company_registration || {};
    },

    companyCountryName() {
      return this.countryNameFromValue(
        this.companyRegistration?.country || this.client?.country_id,
      );
    },

    displayName() {
      if (Number(this.client?.owner_type) === 2) {
        return this.client?.company_name || this.client?.fname || "N/A";
      }

      return `${this.client?.fname || ""} ${this.client?.lname || ""}`.trim() || "N/A";
    },

    twoFaDialogTitle() {
      if (this.twoFaMode === "disable") return "Disable Two-Factor Authentication";
      if (this.twoFaMode === "activate") return "Enable Two-Factor Authentication";
      return "Enable Two-Factor Authentication";
    },

    twoFaConfirmBtnText() {
      if (this.twoFaMode === "disable") return "Confirm & Disable";
      return "Confirm & Enable";
    },

    profileImageUrl() {
      const url = this.client?.profile_pic_url;
      if (!url) return "";
      if (url.includes(".koingate.net/")) {
        return `https://bucket.koingate.net/${url.split(".koingate.net/")[1]}`;
      }
      return url;
    }
  },
  watch: {
    profileImageUrl() {
      this.profileImageFailed = false;
    },
  },
  methods: {
    ...mapActions("profile", [
      PROFILE__ACTIONS.GETPROFILE,
      PROFILE__ACTIONS.FETCHDOCUMENTS,
      PROFILE__ACTIONS.IDENTITYVERIFICATION,
      PROFILE__ACTIONS.RESIDENCEVERIFICATION,
      PROFILE__ACTIONS.CHANGE_PROFILE_URL,
      PROFILE__ACTIONS.UPDATEPROFILEINFO,
      PROFILE__ACTIONS.DELETEDOCUMENT,

      // ✅ 2FA actions
      PROFILE__ACTIONS.TWOFA_START,     // returns qr + setup_token
      PROFILE__ACTIONS.TWOFA_ENABLE,    // setup enable (otp + setup_token)
      PROFILE__ACTIONS.TWOFA_ACTIVATE,  // enable using saved secret (otp only)
      PROFILE__ACTIONS.TWOFA_DISABLE,   // disable using saved secret (otp only)
    ]),
    ...mapActions("countries", [COUNTRIES__ACTIONS.COUNTRIES]),
    ...mapActions("cities", [CITIES__ACTIONS.CITIES]),
    ...mapActions("states", [STATES__ACTIONS.STATES]),
    ...mapActions("profile", {
      BECOMEANIB: PROFILE__ACTIONS.BECOMEANIB,
    }),

    normalizeCountryId(value) {
      if (!value) return "";
      const matchedCountry = this.countries.find((country) => {
        const rawValue = String(value).trim().toLowerCase();
        return (
          String(country.id) === String(value) ||
          String(country.name || "").trim().toLowerCase() === rawValue ||
          String(country.iso_code || "").trim().toLowerCase() === rawValue
        );
      });

      return matchedCountry?.id || value;
    },

    countryNameFromValue(value) {
      if (!value) return this.client?.countries?.name || "";
      const normalizedValue = this.normalizeCountryId(value);
      return (
        this.countries.find((country) => String(country.id) === String(normalizedValue))?.name ||
        this.client?.countries?.name ||
        value ||
        ""
      );
    },

    SaveMenu(date) {
      this.menu = false;
    },

    // SaveMenu(date) {
    //   this.menu = false;
    // },

    formatMySQLDate(mysqlDate) {


      // Ensure the input is in the correct format
      if (!mysqlDate) return "Invalid date";

      // Replace the "T" with a space to work with the current logic
      const isoFormattedDate = mysqlDate.replace("T", " ").split(".")[0]; // Removes milliseconds
      const [datePart, timePart] = isoFormattedDate.split(" ");
      const [year, month, day] = datePart.split("-");
      const [hour, minute] = timePart.split(":");

      // Convert 24-hour time to 12-hour time
      const hour12 = hour % 12 || 12;
      const amPm = hour >= 12 ? "pm" : "am";

      // Return the formatted date and time
      return `${day}.${month}.${year} - ${hour12}:${minute} ${amPm}`;
    },

    async onCountryChange(value) {
      await this[STATES__ACTIONS.STATES](value);
      this.clientInfo.country = value;
    },

    async onStateChange(value) {
      await this[CITIES__ACTIONS.CITIES](value);
      this.clientInfo.state = value;
    },

    onCityChange(value) {
      this.clientInfo.city = value;
    },


    async updateProfile() {
      try {
        this.isLoading = true;
        if (this.isCompanyAccount) {
          const companyCountryId = this.normalizeCountryId(
            this.companyInfo.country || this.client?.country_id,
          );
          const requestData = {
            company_name: this.companyInfo.company_name || this.client?.company_name,
            trading_name: this.companyInfo.trading_name,
            company_reg_no: this.companyInfo.company_reg_no || this.client?.reg_no,
            reg_no: this.companyInfo.company_reg_no || this.client?.reg_no,
            company_type: this.companyInfo.company_type,
            country: companyCountryId,
            country_id: companyCountryId,
            incorporation_date: this.companyInfo.incorporation_date,
            registered_address: this.companyInfo.registered_address,
            address: this.companyInfo.registered_address,
            city: this.companyInfo.city,
            state: this.companyInfo.state,
            postal_code: this.companyInfo.postal_code,
            phone_no: this.companyInfo.phone_no,
            mobile: this.companyInfo.phone_no,
            website: this.companyInfo.website,
            director_name: this.companyInfo.director_name,
            director_position: this.companyInfo.director_position,
            director_email: this.companyInfo.director_email,
            director_phone: this.companyInfo.director_phone,
            owner_name: this.companyInfo.owner_name,
            owner_percentage: this.companyInfo.owner_percentage,
            owner_control_type: this.companyInfo.owner_control_type,
          };

          await this[PROFILE__ACTIONS.UPDATEPROFILEINFO](requestData);
          return;
        }

        const requestData = {
          country_id: this.clientInfo.country || this.client?.country_id,
          city_id: this.clientInfo.city || this.client?.city_id,
          state_id: this.clientInfo.state || this.client?.state_id,
          postal_code: this.clientInfo.postal_code || this.client?.postal_code,
          address: this.clientInfo.address || this.client?.address,
          dob: this.formatDate(this.date) || this.formatDate(this.client?.dob),
          mobile: this.clientInfo.mobile || this.client?.mobile,
        };
        await this[PROFILE__ACTIONS.UPDATEPROFILEINFO](requestData);

      } catch (error) {
        console.log(error)
      } finally {
        this.clientInfo.country = "";
        this.clientInfo.city = "";
        this.clientInfo.state = "";
        this.clientInfo.postal_code = "";
        this.clientInfo.address = "";
        this.clientInfo.mobile = "";
        this.date = "";
        setTimeout(() => {
          this.isLoading = false;
          this.editDialogOpen = false
        }, 500);
      }

    },

    formatDate(value) {
      if (
        Object.prototype.toString.call(value) === "[object Date]" &&
        !isNaN(value.getTime())
      ) {
        return value.toISOString().split("T")[0];
      }
      const date = new Date(value);
      if (!isNaN(date.getTime())) {
        return date.toISOString().split("T")[0];
      } else {
        return null;
      }
    },

    openFileInput() {
      this.$refs.profileImageInput?.click();
    },

    uploadImage(file) {
      const formData = new FormData();
      formData.append("profile_url", file);
      this[PROFILE__ACTIONS.CHANGE_PROFILE_URL](formData);
    },

    getUploadErrorMessage(error) {
      return error?.response?.data?.message || "Something went wrong during the upload.";
    },

    handleImageChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.uploadImage(file);
      }
    },

    getDocuments(type) {
      return type === 'identity'
        ? this.documentInfo?.identityVerificationDocuments
        : this.documentInfo?.residenceVerificationDocuments;
    },

    openImagePreview(type, data) {
      this.previewImages[type] = data?.document_url;
      this.$set(this.dialogs, `image_${type}_${data?.id}`, true);
    },

    closeDialog(dialogKey) {
      this.$set(this.dialogs, dialogKey, false);
      if (dialogKey.includes('image_')) {
        const type = dialogKey.includes('identity') ? 'identity' : 'residence';
        this.previewImages[type] = "";
      }
    },

    initializeFormData() {
      if (this.isCompanyAccount) {
        const companyRegistration = this.companyRegistration;
        this.companyInfo = {
          company_name: companyRegistration?.company_name || this.client?.company_name || "",
          trading_name: companyRegistration?.trading_name || "",
          company_reg_no: companyRegistration?.company_reg_no || this.client?.reg_no || "",
          company_type: companyRegistration?.company_type || "",
          country: this.normalizeCountryId(companyRegistration?.country || this.client?.country_id),
          incorporation_date: this.formatDate(companyRegistration?.incorporation_date) || "",
          registered_address: companyRegistration?.registered_address || this.client?.address || "",
          city: companyRegistration?.city || "",
          state: companyRegistration?.state || "",
          postal_code: companyRegistration?.postal_code || this.client?.postal_code || "",
          phone_no: companyRegistration?.phone_no || this.client?.mobile || "",
          website: companyRegistration?.website || "",
          director_name: companyRegistration?.director_name || "",
          director_position: companyRegistration?.director_position || "",
          director_email: companyRegistration?.director_email || "",
          director_phone: companyRegistration?.director_phone || "",
          owner_name: companyRegistration?.owner_name || "",
          owner_percentage: companyRegistration?.owner_percentage || "",
          owner_control_type: companyRegistration?.owner_control_type || "",
        };
        return;
      }

      this.clientInfo = {
        country: this.client?.country_id || "",
        city: this.client?.city_id || "",
        state: this.client?.state_id || "",
        postal_code: this.client?.postal_code || "",
        address: this.client?.address || "",
        mobile: this.client?.mobile || "",
      };
      this.date = this.formatDate(this.client?.dob) || "";

      if (this.client?.country_id) {
        this[STATES__ACTIONS.STATES](this.client.country_id);
      }
      if (this.client?.state_id) {
        this[CITIES__ACTIONS.CITIES](this.client.state_id);
      }
    },

    handleIdentityFile(event) {
      const file = event.target.files[0];
      this.identityVerificationFileUpload(file);
    },

    handleResidenceFile(event) {
      const file = event.target.files[0];
      this.residenceVerificationFileUpload(file);
    },

    removeIdentityFile() {
      if (this.$refs.identityFileInput) {
        this.$refs.identityFileInput.value = "";
      }
    },

    removeResidenceFile() {
      if (this.$refs.residenceFileInput) {
        this.$refs.residenceFileInput.value = "";
      }
    },

    async identityVerificationFileUpload(file) {
      this.identityUploading = true;
      try {
        if (!file) {
          toast.error("Please select a file to upload!");
          this.removeIdentityFile();
          return;
        }

        if (file.size > 4 * 1024 * 1024) {
          toast.error("File size should be less than 4MB");
          this.removeIdentityFile();
          return;
        }

        const allowedFileTypes = ["image/jpeg", "image/jpg", "image/png"];
        if (!allowedFileTypes.includes(file.type)) {
          toast.error("Invalid file format. Upload JPG, JPEG, or PNG only.");
          this.removeIdentityFile();
          return;
        }

        const formData = new FormData();
        formData.append("identityVerification", file);

        await this[PROFILE__ACTIONS.IDENTITYVERIFICATION](formData);

      } catch (error) {
        console.error("Upload error:", error);
        toast.error(this.getUploadErrorMessage(error));
      } finally {
        this.identityUploading = false;
        this.removeIdentityFile();
      }
    },

    async residenceVerificationFileUpload(file) {
      this.residentUploading = true;

      try {
        // No file
        if (!file) {
          toast.error("Please select a file to upload!");
          this.removeResidenceFile();
          return;
        }

        // Max size 4MB
        if (file.size > 4 * 1024 * 1024) {
          toast.error("File size should be less than 4MB");
          this.removeResidenceFile();
          return;
        }

        // Allowed formats
        const allowedFileTypes = ["image/jpeg", "image/jpg", "image/png"];
        if (!allowedFileTypes.includes(file.type)) {
          toast.error("Invalid file format. Upload JPG, JPEG, or PNG only.");
          this.removeResidenceFile();
          return;
        }

        // Prepare formData
        const formData = new FormData();
        formData.append("residenceVerification", file);

        // Send to backend
        await this[PROFILE__ACTIONS.RESIDENCEVERIFICATION](formData);

      } catch (error) {
        console.error("Upload error:", error);
        toast.error(this.getUploadErrorMessage(error));
      } finally {
        this.residentUploading = false;

        // Clear file input
        this.removeResidenceFile();
      }
    },

    async deleteImage(type, data) {
      const docId = data?.id;
      if (!docId) return;
      this.$set(this.closeLoading, docId, true);
      try {
        await this[PROFILE__ACTIONS.DELETEDOCUMENT](docId);
        await this[PROFILE__ACTIONS.FETCHDOCUMENTS]();
      } catch (error) {
        console.error("Upload error:", error);
        toast.error("Something went wrong during delete Image.");
      } finally {
        setTimeout(() => {
          this.$delete(this.closeLoading, docId);
        }, 500);
      }
    },

    // ✅ Toggle dialog open (Enable/Disable)
    async open2faToggleDialog() {
      this.twoFaOtp = "";
      this.twoFaDialog = true;

      // If currently enabled -> disable mode
      if (this.is2faEnabled) {
        this.twoFaMode = "disable";
        this.twoFaLoading = false;
        return;
      }

      // If disabled -> either setup (no secret) or activate (secret exists)
      if (this.has2faSecret) {
        this.twoFaMode = "activate";
        this.twoFaLoading = false;
        return;
      }

      // Not registered -> setup mode: fetch QR + setup_token
      this.twoFaMode = "setup";
      this.twoFaLoading = true;
      try {
        await this[PROFILE__ACTIONS.TWOFA_START]();
      } catch (e) {
        toast.error("Failed to start 2FA setup");
        this.twoFaDialog = false;
      } finally {
        this.twoFaLoading = false;
      }
    },

    close2faDialog() {
      this.twoFaDialog = false;
      this.twoFaOtp = "";
      this.twoFaConfirmLoading = false;
      this.twoFaLoading = false;
      this.$store.commit("profile/CLEAR_TWOFA_SETUP");
    },

    // ✅ Confirm enable/activate/disable based on mode
    async confirmTwoFaToggle() {
      if ((this.twoFaOtp || "").length !== 6) return;

      this.twoFaConfirmLoading = true;
      try {
        // setup: otp + setup_token
        if (this.twoFaMode === "setup") {
          if (!this.twoFaSetup?.setup_token) {
            toast.error("2FA setup token missing. Please try again.");
            return;
          }

          const ok = await this[PROFILE__ACTIONS.TWOFA_ENABLE]({
            otp: this.twoFaOtp,
            setup_token: this.twoFaSetup.setup_token,
          });

          if (ok) toast.success("2FA enabled successfully");
        }

        // activate: otp only against saved secret
        if (this.twoFaMode === "activate") {
          const ok = await this[PROFILE__ACTIONS.TWOFA_ACTIVATE]({
            otp: this.twoFaOtp,
          });

          if (ok) toast.success("2FA enabled successfully");
        }

        // disable: otp only against saved secret
        if (this.twoFaMode === "disable") {
          const ok = await this[PROFILE__ACTIONS.TWOFA_DISABLE]({
            otp: this.twoFaOtp,
          });

          if (ok) toast.success("2FA disabled successfully");
        }

        this.close2faDialog();
        await this[PROFILE__ACTIONS.GETPROFILE](); // refresh flags
      } catch (e) {
        toast.error("Invalid OTP or failed action");
      } finally {
        this.twoFaConfirmLoading = false;
      }
    },


  },
  async mounted() {
    try {
      await this[COUNTRIES__ACTIONS.COUNTRIES]();
      await this[PROFILE__ACTIONS.GETPROFILE]();
      await this[PROFILE__ACTIONS.FETCHDOCUMENTS]();
      await this[PROFILE__ACTIONS.GETPROFILE]();
      console.log("PROFILE =>", this.client);
      console.log("client_2fa_enabled =>", this.client?.client_2fa_enabled);
      console.log(this.client)
    } catch (error) {
      console.log(error);
    }
  },
};
</script>

<style scoped>
.profileView {
  --profile-page: #f7f8fa;
  --profile-card: #ffffff;
  --profile-card-soft: #fbfaf6;
  --profile-border: #e0e3e7;
  --profile-text: #15181d;
  --profile-muted: #626973;
  --profile-blue: #d99a00;
  --profile-purple: #d99a00;
  --profile-green: #13b981;
  min-height: calc(100vh - 64px);
  color: var(--profile-text);
  background:
    radial-gradient(circle at 85% 4%, rgba(217, 154, 0, 0.06), transparent 24%),
    var(--profile-page);
}

.profileView--dark {
  --profile-page: #030b13;
  --profile-card: #07111b;
  --profile-card-soft: #0b1621;
  --profile-border: #293026;
  --profile-text: #f5f7fb;
  --profile-muted: #adb5bf;
  --profile-blue: #e3a600;
  --profile-purple: #e3a600;
  --profile-green: #26d6a0;
  background:
    radial-gradient(circle at 78% 0%, rgba(227, 166, 0, 0.06), transparent 30%),
    var(--profile-page);
}

.profileView:not(.profileView--dark) {
  --profile-text: #111827;
  --profile-muted: #52627a;
  --profile-blue: #c78e00;
  --profile-purple: #c78e00;
  --profile-green: #07875f;
}

.profileView:not(.profileView--dark) .profile-status-card .v-card__subtitle,
.profileView:not(.profileView--dark) .security-summary-row .v-card__subtitle,
.profileView:not(.profileView--dark) .terms-summary-row .v-card__subtitle {
  color: #52627a !important;
}

.profileView:not(.profileView--dark) .personal-information-card .listing-v-card__subtitle span:first-child {
  color: #344054 !important;
  font-weight: 500;
}

.profileView:not(.profileView--dark) .personal-information-card .listing-v-card__subtitle span:last-child {
  color: #101828 !important;
  font-weight: 500;
}

.profileView:not(.profileView--dark) .custom-upload-area,
.profileView:not(.profileView--dark) .verification-card > .v-card__subtitle,
.profileView:not(.profileView--dark) .verification-card > .content {
  color: #52627a !important;
}

.profileView:not(.profileView--dark) .verification-card > .content h3 {
  color: #1f2937;
}

.profileView:not(.profileView--dark) .verification-history-row {
  color: #253247;
}

.profileView:not(.profileView--dark) .verification-history-head {
  color: #52627a;
}

.profileView:not(.profileView--dark) .verification-history-row button,
.profileView:not(.profileView--dark) .link,
.profileView:not(.profileView--dark) .see-details-btn {
  color: #b47f00 !important;
}

.profileView:not(.profileView--dark) .history-status--1 {
  color: #087a55;
  background: #c9f0df;
}

.profileView:not(.profileView--dark) .history-status--2 {
  color: #8a5a00;
  background: #ffedb3;
}

.profileView:not(.profileView--dark) .history-status--0 {
  color: #b42342;
  background: #ffd9e1;
}

.custom-container {
  width: 100%;
  max-width: none;
  padding: 28px 28px 38px;
}

.custom-container > .row {
  margin-top: 0;
  margin-bottom: 8px;
}

.profileView .v-card {
  color: var(--profile-text) !important;
  background: var(--profile-card) !important;
  border: 1px solid var(--profile-border) !important;
  border-radius: 10px !important;
  box-shadow: 0 12px 35px rgba(4, 15, 32, 0.04) !important;
}

.profileView--dark .v-card {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.012), 0 14px 34px rgba(0, 0, 0, 0.12) !important;
}

.profileView .v-card__title,
.profileView .v-card__subtitle,
.profileView .v-card__text {
  color: inherit;
}

.profileView .v-card__title {
  font-size: 15px;
  font-weight: 600;
}

.profileView .v-card__subtitle,
.profileView .v-card__text {
  font-size: 13px;
}

.profileView .v-card__subtitle {
  color: var(--profile-muted) !important;
}

.my-profile {
  min-height: 96px;
}

.profile-status-card {
  background: linear-gradient(115deg, var(--profile-card), var(--profile-card-soft)) !important;
}

.profile-status-card:first-child .v-icon {
  color: var(--profile-blue) !important;
}

.profile-status-card > .v-card__actions > .v-icon {
  display: grid;
  width: 46px;
  height: 46px;
  margin-top: 18px !important;
  padding: 0;
  place-items: center;
  color: var(--profile-blue) !important;
  background: rgba(227, 166, 0, 0.12);
  border-radius: 50%;
}

.user-profile-card {
  position: relative;
  min-height: 218px;
}

.verified-profile-tag {
  display: inline-flex;
  padding: 4px 8px;
  align-items: center;
  gap: 4px;
  color: #ffffff;
  background: var(--profile-purple);
  border-radius: 5px;
  font-size: 10px;
  line-height: 14px;
}

.verified-profile-tag .v-icon {
  color: #ffffff !important;
  font-size: 13px !important;
}

.user-profile-card .v-avatar {
  width: 124px !important;
  min-width: 124px !important;
  height: 124px !important;
  border-color: var(--profile-blue) !important;
  box-shadow: 0 0 0 5px rgba(227, 166, 0, 0.1);
}

.default-profile-avatar {
  width: 100%;
  height: 100%;
  color: var(--profile-blue) !important;
  background: linear-gradient(145deg, rgba(255, 196, 0, 0.2), rgba(227, 166, 0, 0.08));
  font-size: 74px !important;
}

.profile-identity-layout {
  display: grid;
  min-height: 218px;
  padding: 20px 28px;
  grid-template-columns: 128px minmax(0, 1fr) auto;
  gap: 28px;
  align-items: center;
}

.profile-avatar-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
}

.profile-avatar-control {
  position: relative;
  display: inline-flex;
}

.profile-image-button {
  position: absolute;
  z-index: 2;
  top: -4px;
  right: -7px;
  display: grid;
  width: 34px;
  height: 34px;
  padding: 0;
  place-items: center;
  color: #ffffff;
  background: linear-gradient(145deg, #ffc826, #a97700);
  border: 3px solid var(--profile-card);
  border-radius: 50%;
  box-shadow: 0 5px 14px rgba(191, 137, 0, 0.3);
  cursor: pointer;
}

.profile-image-button .v-icon {
  color: #ffffff !important;
  font-size: 17px !important;
}

.profile-image-button:hover {
  transform: translateY(-1px);
  filter: brightness(1.08);
}

.profile-identity-details {
  min-width: 0;
  align-self: center;
}

.profile-name-row {
  display: flex;
  margin-bottom: 28px;
  align-items: center;
  gap: 12px;
}

.profile-name-row h3 {
  margin: 0;
  color: var(--profile-text);
  font-size: 17px;
  font-weight: 600;
  line-height: 22px;
}

.profile-contact-list {
  display: flex;
  max-width: 390px;
  margin: 0;
  flex-direction: column;
  gap: 20px;
}

.profile-contact-list > div {
  display: grid;
  grid-template-columns: 68px minmax(0, 1fr);
  gap: 18px;
  align-items: center;
}

.profile-contact-list dt {
  color: var(--profile-muted);
  font-size: 12px;
}

.profile-contact-list dd {
  min-width: 0;
  margin: 0;
  color: var(--profile-text);
  font-size: 13px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.change-profile-password-button {
  display: inline-flex;
  height: 39px;
  padding: 0 16px;
  align-self: center;
  align-items: center;
  gap: 8px;
  color: var(--profile-blue);
  background: rgba(227, 166, 0, 0.05);
  border: 1px solid var(--profile-blue);
  border-radius: 5px;
  font-family: inherit;
  font-size: 12px;
  white-space: nowrap;
  cursor: pointer;
}

.change-profile-password-button .v-icon {
  color: var(--profile-blue) !important;
  font-size: 18px;
}

.change-profile-password-button:hover {
  color: #17130a;
  background: linear-gradient(135deg, #ffc826, #d99a00);
}

.change-profile-password-button:hover .v-icon {
  color: #ffffff !important;
}

.profile-password-modal {
  --profile-card: #ffffff;
  --profile-card-soft: #f6f8fc;
  --profile-border: #dbe4ef;
  --profile-text: #101828;
  --profile-muted: #667085;
  width: 100%;
  max-height: min(680px, 82vh);
  overflow-y: auto;
  color: var(--profile-text);
  background: var(--profile-card);
  border: 1px solid var(--profile-border);
  border-radius: 12px;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.34);
}

.profile-password-modal--dark {
  --profile-card: #081526;
  --profile-card-soft: #0c1a2c;
  --profile-border: #21334c;
  --profile-text: #f5f7fb;
  --profile-muted: #9aa9be;
}

.verification-detail-modal {
  --detail-bg: #ffffff;
  --detail-soft: #f5f8fc;
  --detail-border: #dbe4ef;
  --detail-text: #101828;
  --detail-muted: #52627a;
  width: 100%;
  overflow: hidden;
  color: var(--detail-text) !important;
  background: var(--detail-bg) !important;
  border: 1px solid var(--detail-border) !important;
  border-radius: 12px !important;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.32) !important;
}

.verification-detail-modal--dark {
  --detail-bg: #081526;
  --detail-soft: #0c1a2c;
  --detail-border: #21334c;
  --detail-text: #f5f7fb;
  --detail-muted: #9aa9be;
}

.verification-detail-header {
  display: flex;
  min-height: 68px;
  padding: 14px 16px 14px 20px;
  align-items: center;
  justify-content: space-between;
  background: var(--detail-bg);
  border-bottom: 1px solid var(--detail-border);
}

.verification-detail-header > div {
  display: flex;
  align-items: center;
  gap: 11px;
}

.verification-detail-header h2 {
  margin: 0;
  color: var(--detail-text);
  font-size: 17px;
  font-weight: 600;
}

.verification-detail-header .v-icon {
  color: #5e82ff !important;
}

.verification-detail-header > .v-btn .v-icon {
  color: var(--detail-muted) !important;
}

.verification-detail-body {
  padding: 20px;
  color: var(--detail-muted);
  background: var(--detail-bg);
  font-size: 13px;
  line-height: 20px;
}

.verification-detail-body > p {
  margin: 0 0 18px;
}

.verification-detail-body h3 {
  margin: 0 0 10px;
  color: var(--detail-text);
  font-size: 14px;
}

.verification-detail-body ul {
  display: grid;
  margin: 0 0 18px;
  padding-left: 19px;
  gap: 5px;
}

.verification-detail-note {
  display: flex;
  padding: 12px 14px;
  align-items: flex-start;
  gap: 10px;
  background: var(--detail-soft);
  border: 1px solid var(--detail-border);
  border-radius: 7px;
}

.verification-detail-note .v-icon {
  margin-top: 1px;
  color: #5e82ff !important;
  font-size: 19px;
}

.profile-edit-modal {
  --edit-bg: #ffffff;
  --edit-soft: #f6f8fc;
  --edit-border: #dbe4ef;
  --edit-text: #101828;
  --edit-muted: #52627a;
  max-height: min(720px, 84vh);
  padding: 0 !important;
  overflow-y: auto;
  color: var(--edit-text) !important;
  background: var(--edit-bg) !important;
  border: 1px solid var(--edit-border) !important;
  border-radius: 12px !important;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.32) !important;
}

.profile-edit-modal--dark {
  --edit-bg: #081526;
  --edit-soft: #0c1a2c;
  --edit-border: #21334c;
  --edit-text: #f5f7fb;
  --edit-muted: #9aa9be;
}

.profile-edit-modal__header {
  position: sticky;
  z-index: 5;
  top: 0;
  display: flex;
  min-height: 68px;
  padding: 14px 16px 14px 20px;
  align-items: center;
  justify-content: space-between;
  background: var(--edit-bg);
  border-bottom: 1px solid var(--edit-border);
}

.profile-edit-modal__header > div {
  display: flex;
  align-items: center;
  gap: 11px;
}

.profile-edit-modal__header h2 {
  margin: 0;
  color: var(--edit-text);
  font-size: 17px;
  font-weight: 600;
}

.profile-edit-modal__header .v-icon {
  color: #d99a00 !important;
}

.profile-edit-modal__header > .v-btn .v-icon {
  color: var(--edit-muted) !important;
}

.profile-edit-modal__body {
  margin: 0 !important;
  padding: 18px;
  background: var(--edit-bg);
}

.profile-edit-modal fieldset {
  color: var(--edit-muted);
  background: var(--edit-soft);
  border-color: var(--edit-border) !important;
  border-radius: 7px;
}

.profile-edit-modal legend {
  color: var(--edit-muted);
}

::v-deep .profile-edit-modal .v-input__slot {
  color: var(--edit-text) !important;
  background-color: var(--edit-soft) !important;
  background-image: none !important;
  box-shadow: none !important;
}

::v-deep .profile-edit-modal .v-text-field--solo > .v-input__control > .v-input__slot,
::v-deep .profile-edit-modal .v-textarea > .v-input__control > .v-input__slot,
::v-deep .profile-edit-modal .custom-select-datepicker > .v-input__control > .v-input__slot {
  color: var(--edit-text) !important;
  background-color: var(--edit-soft) !important;
  background-image: none !important;
  border: 1px solid var(--edit-border) !important;
  border-radius: 6px !important;
  box-shadow: none !important;
}

::v-deep .profile-edit-modal fieldset .v-text-field--solo > .v-input__control > .v-input__slot,
::v-deep .profile-edit-modal fieldset .v-textarea > .v-input__control > .v-input__slot,
::v-deep .profile-edit-modal fieldset .custom-select-datepicker > .v-input__control > .v-input__slot {
  border: 0 !important;
  border-radius: 0 !important;
}

::v-deep .profile-edit-modal input,
::v-deep .profile-edit-modal textarea,
::v-deep .profile-edit-modal .v-select__selection,
::v-deep .profile-edit-modal .v-label {
  color: var(--edit-text) !important;
}

::v-deep .profile-edit-modal .btn-account {
  height: 40px;
  color: #ffffff !important;
  background: linear-gradient(135deg, #ffc826, #d99a00) !important;
  border-radius: 5px !important;
  box-shadow: 0 7px 18px rgba(191, 137, 0, 0.2) !important;
}

.profileView .edit,
.profileView .link {
  color: var(--profile-blue) !important;
  font-weight: 500;
  text-decoration-color: rgba(139, 120, 255, 0.55) !important;
}

.profileView .edit:hover,
.profileView .link:hover {
  color: #ffc400 !important;
}

.profileView:not(.profileView--dark) .edit,
.profileView:not(.profileView--dark) .link {
  color: #b47f00 !important;
  text-decoration-color: rgba(180, 127, 0, 0.45) !important;
}

.profileView:not(.profileView--dark) .edit:hover,
.profileView:not(.profileView--dark) .link:hover {
  color: #8d6400 !important;
}

.profile-password-modal__header {
  position: sticky;
  z-index: 4;
  top: 0;
  display: flex;
  padding: 17px 20px;
  align-items: center;
  justify-content: space-between;
  background: var(--profile-card);
  border-bottom: 1px solid var(--profile-border);
}

.profile-password-modal__header h2 {
  margin: 0 0 5px;
  color: var(--profile-text);
  font-size: 17px;
}

.profile-password-modal__header p {
  margin: 0;
  color: var(--profile-muted);
  font-size: 12px;
}

.profile-password-modal__close .v-icon {
  color: var(--profile-muted) !important;
}

::v-deep .profile-password-modal .password-stepper {
  background: transparent !important;
  box-shadow: none !important;
}

::v-deep .profile-password-modal .v-stepper__header {
  min-height: 64px;
  box-shadow: none;
  border-bottom: 1px solid var(--profile-border);
}

::v-deep .profile-password-modal .v-stepper__step {
  padding: 16px 10px;
}

::v-deep .profile-password-modal .v-stepper__label {
  font-size: 11px;
}

::v-deep .profile-password-modal .v-stepper__content {
  padding: 18px 20px 22px;
}

::v-deep .profile-password-modal .v-stepper__content > .v-card.mb-3 {
  display: none;
}

::v-deep .profile-password-modal .deposit-form {
  width: 100%;
  max-width: none !important;
  margin: 0 !important;
  padding: 18px !important;
  color: var(--profile-text) !important;
  background: var(--profile-card-soft) !important;
  border: 1px solid var(--profile-border) !important;
  border-radius: 8px !important;
}

::v-deep .profile-password-modal .deposit-form .v-card__title {
  padding: 0 0 12px;
  font-size: 15px;
}

::v-deep .profile-password-modal .deposit-form .v-card__text {
  padding: 0 0 14px;
  font-size: 12px;
}

::v-deep .profile-password-modal .deposit-form fieldset {
  margin-bottom: 14px;
}

::v-deep .profile-password-modal .deposit-form .btn-account {
  width: auto !important;
  min-width: 150px;
  height: 40px;
  color: #ffffff !important;
  background: linear-gradient(135deg, #ffc826, #d99a00) !important;
  border-radius: 5px !important;
}

.personal-information-card > .v-card__title {
  position: static;
  padding: 18px 20px 12px;
}

.personal-information-card > .v-card__actions {
  min-height: 150px;
  padding: 8px 20px 20px;
}

.personal-information-card > .v-card__title > .v-icon {
  display: inline-flex;
}

.listing-v-card__subtitle {
  display: grid;
  grid-template-columns: minmax(92px, 0.7fr) 1fr;
  gap: 10px;
}

.listing-v-card__subtitle span:first-child {
  color: var(--profile-muted);
}

.listing-v-card__subtitle span:last-child {
  color: var(--profile-text);
}

.edit,
.see-details-btn {
  color: var(--profile-blue) !important;
}

.security-summary-row,
.terms-summary-row {
  display: inline-flex;
  width: calc(50% - 3px);
  vertical-align: top;
}

.security-summary-row {
  padding-right: 4px;
}

.terms-summary-row {
  padding-left: 4px;
}

.security-summary-row .v-card,
.terms-summary-row .v-card {
  min-height: 92px;
}

.security-summary-row + .terms-summary-row + .verification-summary-row,
.verification-summary-row {
  clear: both;
}

.profileView .v-btn:not(.v-btn--icon):not(.v-btn--text) {
  border-radius: 5px !important;
  text-transform: none;
}

.ib-partner-button,
.terms-action-button {
  height: 38px !important;
  padding: 0 18px !important;
  color: var(--profile-blue) !important;
  background-color: transparent !important;
  background-image: none !important;
  border: 1px solid var(--profile-blue) !important;
  box-shadow: none !important;
}

.ib-partner-button.v-btn--disabled {
  color: #a783ff !important;
  opacity: 1;
}

.ib-partner-button.v-btn--disabled .v-btn__content {
  color: #a783ff !important;
  opacity: 1;
}

.terms-action-button .v-btn__content {
  color: var(--profile-blue) !important;
  opacity: 1 !important;
  visibility: visible !important;
}

::v-deep .terms-action-button .v-btn__content {
  color: var(--profile-blue) !important;
  opacity: 1 !important;
  visibility: visible !important;
}

.profileView:not(.profileView--dark) .terms-action-button {
  color: #b47f00 !important;
  border-color: #c78e00 !important;
}

.profileView:not(.profileView--dark) .terms-action-button .v-btn__content {
  color: #b47f00 !important;
}

::v-deep .profileView:not(.profileView--dark) .terms-action-button .v-btn__content {
  color: #b47f00 !important;
}

.profileView:not(.profileView--dark) .change-profile-password-button,
.profileView:not(.profileView--dark) .view-history-button {
  color: #b47f00;
  background: #fffbf0;
  border-color: #c78e00;
}

.profileView:not(.profileView--dark) .change-profile-password-button .v-icon,
.profileView:not(.profileView--dark) .view-history-button .v-icon {
  color: #b47f00 !important;
}

.ib-partner-button::before {
  opacity: 0 !important;
}

.security-action-button {
  height: 40px !important;
  padding: 0 18px !important;
  color: #17130a !important;
  background: linear-gradient(135deg, #ffc826, #d99a00) !important;
  box-shadow: 0 7px 18px rgba(191, 137, 0, 0.24) !important;
}

.ib-action-button,
.ib-action-button.v-btn--disabled {
  color: #17130a !important;
  background-color: #d99a00 !important;
  background-image: linear-gradient(135deg, #ffc826, #d99a00) !important;
  border: 0 !important;
  opacity: 1;
}

.ib-action-button.v-btn--disabled .v-btn__content {
  color: #ffffff !important;
  opacity: 0.72;
}

.verification-card {
  min-height: 330px;
  padding: 8px 16px 16px;
  overflow: hidden;
}

.verification-card > .v-card__actions {
  border-bottom: 1px solid rgba(125, 145, 174, 0.09);
}

.verification-card > .content {
  min-height: 230px;
  gap: 10px;
  align-items: center;
  text-align: center;
}

.verification-card.pb-0 > .content {
  min-height: 142px;
  height: 142px;
}

.verification-card > .content .v-icon {
  width: 58px;
  height: 58px;
  margin-bottom: 2px;
  color: #ffffff !important;
  color: #17130a !important;
  background: linear-gradient(145deg, #ffc826, #a97700);
  border-radius: 50%;
  box-shadow: 0 0 25px rgba(227, 166, 0, 0.2);
}

.verification-summary-row > div:last-child .verification-card > .content .v-icon {
  background: linear-gradient(145deg, #ffc826, #a97700);
  box-shadow: 0 0 25px rgba(227, 166, 0, 0.2);
}

.custom-upload-area {
  min-height: 185px !important;
  color: var(--profile-muted);
  background: rgba(227, 166, 0, 0.025);
  border-color: rgba(227, 166, 0, 0.55) !important;
}

.custom-upload-area:hover {
  background: rgba(227, 166, 0, 0.07) !important;
  border-color: var(--profile-blue) !important;
}

.custom-upload-area strong {
  color: var(--profile-blue);
}

.document-history-row {
  display: none;
}

.document-history-row > .col {
  padding-top: 0;
  padding-bottom: 0;
  overflow: hidden;
  background: var(--profile-card);
  border: 1px solid var(--profile-border);
  border-radius: 10px;
}

.verification-history {
  padding: 0 6px 15px;
}

.verification-history--unverified {
  margin-top: 14px;
  padding-top: 4px;
  border-top: 1px solid rgba(125, 145, 174, 0.13);
}

.verification-history-row {
  display: grid;
  min-height: 39px;
  padding: 0 2px;
  grid-template-columns: 1.45fr 1fr 0.85fr 0.55fr;
  gap: 12px;
  align-items: center;
  color: var(--profile-text);
  border-bottom: 1px solid rgba(125, 145, 174, 0.13);
  font-size: 11px;
}

.verification-history-head {
  min-height: 30px;
  color: var(--profile-muted);
  font-weight: 400;
}

.verification-history-row strong {
  font-weight: 500;
}

.verification-history-row button {
  width: max-content;
  padding: 0;
  color: var(--profile-blue);
  background: transparent;
  border: 0;
  text-decoration: underline;
  cursor: pointer;
}

.history-status {
  width: max-content;
  padding: 4px 9px;
  border-radius: 5px;
}

.history-status--1 {
  color: #35e7ad;
  background: rgba(8, 139, 96, 0.32);
}

.history-status--2 {
  color: #ffd167;
  background: rgba(190, 131, 12, 0.22);
}

.history-status--0 {
  color: #ff718f;
  background: rgba(190, 40, 75, 0.2);
}

.view-history-button {
  display: flex;
  height: 34px;
  margin: 12px auto 0;
  padding: 0 15px;
  align-items: center;
  gap: 6px;
  color: var(--profile-blue);
  background: transparent;
  border: 1px solid var(--profile-blue);
  border-radius: 5px;
  font-size: 11px;
  cursor: pointer;
}

.view-history-button .v-icon {
  color: var(--profile-blue);
  font-size: 16px;
}

.document-history-row > .col:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.document-history-row > .col:last-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.listing-upload {
  min-height: 54px;
  margin: 0;
  overflow: hidden;
  border: 0 !important;
  border-bottom: 1px solid var(--profile-border) !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.listing-upload:last-child {
  border-bottom: 0 !important;
}

.listing-upload:first-child {
  min-height: 72px;
}

.listing-upload .v-card__title,
.listing-upload .v-card__subtitle {
  font-size: 12px;
}

.listing-upload:not(:first-child) .v-card__title {
  display: none;
}

.listing-upload:not(:first-child) .v-card__subtitle {
  padding-top: 16px;
}

.verification-benefits {
  position: relative;
  display: grid;
  min-height: 126px;
  margin-top: 8px;
  padding: 25px 170px 25px 28px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 22px;
  align-items: center;
  overflow: hidden;
  color: var(--profile-text);
  background: var(--profile-card);
  border: 1px solid var(--profile-border);
  border-radius: 10px;
}

.verification-benefit {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 14px;
}

.verification-benefit strong {
  display: block;
  margin-bottom: 7px;
  font-size: 13px;
}

.verification-benefit p {
  margin: 0;
  color: var(--profile-muted);
  font-size: 11px;
  line-height: 17px;
}

.benefit-icon {
  display: grid;
  width: 54px;
  height: 54px;
  flex: 0 0 54px;
  place-items: center;
  border-radius: 50%;
}

.benefit-icon--purple { background: rgba(118, 87, 246, 0.13); }
.benefit-icon--green { background: rgba(19, 185, 129, 0.13); }
.benefit-icon--gold { background: rgba(221, 167, 40, 0.14); }
.benefit-icon--blue { background: rgba(40, 120, 240, 0.13); }
.benefit-icon--purple .v-icon { color: var(--profile-purple); }
.benefit-icon--green .v-icon { color: var(--profile-green); }
.benefit-icon--gold .v-icon { color: #d6a429; }
.benefit-icon--blue .v-icon { color: var(--profile-blue); }

.benefits-shield {
  position: absolute;
  right: 38px;
  color: var(--profile-blue) !important;
  font-size: 94px !important;
  opacity: 0.68;
  filter: drop-shadow(0 0 20px rgba(227, 166, 0, 0.22));
}

@media (max-width: 1250px) {
  .verification-benefits {
    padding-right: 26px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .benefits-shield {
    display: none;
  }
}

@media (max-width: 959px) {
  .security-summary-row,
  .terms-summary-row {
    display: flex;
    width: auto;
    padding: 0;
  }

  .custom-container {
    padding: 16px;
  }
}

@media (max-width: 650px) {
  .profileView {
    width: 100%;
    height: calc(100dvh - 56px);
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
  }

  .custom-container {
    width: 100%;
    padding: 10px 10px 36px;
    overflow: visible;
  }

  .custom-container > .row {
    width: auto;
    margin-right: -4px;
    margin-left: -4px;
  }

  .custom-container > .row > .col {
    min-width: 0;
    padding: 4px;
  }

  .profileView .v-card {
    width: 100%;
    max-width: 100%;
    overflow: visible;
  }

  .user-profile-card,
  .identity-profile-card,
  .personal-information-card {
    height: auto !important;
    min-height: 0 !important;
  }

  .verification-benefits {
    grid-template-columns: 1fr;
  }

  .my-profile {
    align-items: flex-start !important;
    flex-direction: column;
  }

  .document-history-row > .col:first-child,
  .document-history-row > .col:last-child {
    border-radius: 10px;
  }

  .profile-identity-layout {
    min-height: 0;
    padding: 22px 18px;
    grid-template-columns: 1fr;
    gap: 16px;
    text-align: center;
  }

  .profile-name-row {
    margin-bottom: 20px;
    justify-content: center;
  }

  .profile-contact-list {
    width: 100%;
    max-width: none;
    margin: 0 auto;
    gap: 12px;
    text-align: left;
  }

  .profile-contact-list > div {
    grid-template-columns: 72px minmax(0, 1fr);
    gap: 12px;
  }

  .change-profile-password-button {
    width: 100%;
    justify-content: center;
  }

  .personal-information-card > .v-card__title {
    padding: 16px 16px 10px;
  }

  .personal-information-card > .v-card__actions {
    display: flex !important;
    height: auto !important;
    min-height: 0;
    padding: 8px 18px 18px !important;
    flex-direction: column;
    align-items: stretch;
    gap: 0;
  }

  .personal-information-card > .v-card__actions > .v-card__text {
    width: 100%;
    min-width: 0;
    padding: 0 !important;
  }

  .listing-v-card__subtitle {
    width: 100%;
    grid-template-columns: minmax(105px, 40%) minmax(0, 1fr);
    gap: 10px;
    align-items: start;
  }

  .listing-v-card__subtitle span {
    min-width: 0;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  .security-summary-row,
  .terms-summary-row,
  .verification-summary-row {
    display: flex;
    width: 100%;
    margin-right: 0;
    margin-left: 0;
  }

  .document-history-row {
    display: none !important;
  }

  .security-summary-row .my-profile,
  .terms-summary-row .my-profile {
    height: auto;
    min-height: 0;
    padding-bottom: 14px;
  }

  .security-summary-row .v-card__actions,
  .terms-summary-row .v-card__actions {
    width: 100%;
    padding-right: 14px !important;
    padding-left: 14px !important;
  }

  .verification-card {
    height: auto !important;
    min-height: 0;
  }

  .verification-card > .content,
  .verification-card.pb-0 > .content {
    height: auto;
    min-height: 200px;
  }

  .verification-history-row {
    min-height: 0;
    padding: 10px 4px;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 10px 14px;
    align-items: center;
    overflow: visible;
  }

  .verification-history-head {
    display: none;
  }

  .verification-history-row strong,
  .verification-history-row button,
  .verification-history-row span {
    min-width: 0;
    max-width: 100%;
    overflow-wrap: anywhere;
  }

  .verification-history-row button {
    justify-self: start;
  }

  .verification-history-row .history-status {
    justify-self: start;
  }

  .verification-history-row > span:last-child {
    justify-self: start;
    color: var(--profile-muted);
  }

  .verification-benefits {
    padding: 20px 16px;
  }
}

.closeBtn {
  background: none !important;
  box-shadow: none;
}

.closeBtn:hover {
  box-shadow: none;
}

.align-center {
  text-align: center;
}

.content {
  padding: 0 !important;
  height: calc(100% - 120px);
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
}


.custom-upload-area {
  border: 1px dashed rgba(227, 166, 0, 0.55);
  border-radius: 6px;
  padding: 20px;
  position: relative;
  cursor: pointer;
  min-height: 180px;
  text-align: center;
}

.custom-upload-area:hover {
  background: rgba(112, 138, 167, 0.08);
}

.file-input {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  cursor: pointer;
}

.text-sm {
  font-weight: normal;
  font-size: 13px;
}

.twofa-dialog .twofa-card {
  border-radius: 12px !important;
  overflow: hidden;
}

.twofa-header {
  position: relative;
}

.twofa-title {
  font-weight: 700;
  font-size: 18px;
  line-height: 1.2;
}

.twofa-subtitle {
  font-size: 13px;
  opacity: 0.8;
  margin-top: 4px;
}

.twofa-divider {
  opacity: 0.15;
}

.twofa-steps .step-title {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 8px;
}

.step-list {
  margin: 0;
  padding-left: 18px;
  font-size: 13px;
  line-height: 1.6;
  opacity: 0.9;
}

.twofa-qr-wrap,
.twofa-otp-wrap {
  border-radius: 12px;
  padding: 14px;
  border: 1px solid rgba(126, 166, 214, 0.15);
}

.qr-title,
.otp-title {
  font-weight: 700;
  font-size: 14px;
}

.qr-hint,
.otp-note {
  font-size: 12px;
  opacity: 0.75;
}

.twofa-qr {
  border-radius: 10px;
  padding: 8px;
  background: rgba(255, 255, 255, 0.06);
}

.twofa-otp-input {
  border-radius: 10px;
}

.twofa-action {
  width: 100%;
  height: 44px;
  font-weight: 700;
  letter-spacing: 0.3px;
}

.twofa-cancel {
  text-transform: none !important;
  opacity: 0.85;
}
</style>
